import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import { UserCacheService } from '../../user/user-cache.service';

@Injectable({
  providedIn: 'root'
})

export class CountryService {
  countryCode: string = '';
  userAdminCountries: string[] = [];

  constructor(private http: HttpClient) { }

  /**
   * Get countries where current user is admin
   */
  getUserAdminCountries(): Observable<string[]> {
    const url = `${environment.prestoUrl}/admincountries`;

    return this.http.get<string[]>(url);
  }

  setUserAdminCountries(): void {
    this.getUserAdminCountries().subscribe((countries: string[]) => {
      this.userAdminCountries = countries;
    })
  }

  getCountryCode(): string {
    return this.countryCode;
  }

  setCountryCode(code: string): void {
    this.countryCode = code;
  }
}
